import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CmpsIconModule, CmpsIconRegistry } from '@cmps/ng-uikit';
import { mdiFolderHeartOutline } from '@mdi/js';

import { CmpsInsightCoachingWarningBoxComponent } from './insight-coaching-warning-box.component';

@NgModule({
    declarations: [CmpsInsightCoachingWarningBoxComponent],
    imports: [CmpsIconModule],
    exports: [CmpsInsightCoachingWarningBoxComponent],
})
export class CmpsInsightCoachingWarningBoxModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [['folder-heart', mdiFolderHeartOutline]].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
